const {
	emitter,
	EVENT_MARKET_REDIRECT_CLOSE,
	EVENT_MARKET_REDIRECT_INIT,
	EVENT_MAIN_NAV_OPEN,
	EVENT_MAIN_NAV_CLOSE,
	EVENT_MAIN_NAV_FOLDING,
	EVENT_MAIN_NAV_UNFOLDING,
	EVENT_MAIN_NAV_FOCUS,
	DELAY_THROTTLE,
	bodyElement,
} = require('util/consts');
const {
	trackGtm,
	trackGtm4,
	fillWithDomElements,
	fillWithDomElementsAll,
	onControllerReady,
	freezeScroll,
	unfreezeScroll,
	awaitNextFrame,
	awaitEventOn,
} = require('util/functions');
const asyncImport = require('util/asyncImport').default;

const CLASS_MOBILE_NAV_BURGER = 'mobile-nav--burger';
const CLASS_IS_NAVIGATION = 'is-navigation';
const CLASS_MOBILE_NAV_PANELS = 'mobile-nav--panel';
const CLASS_MOBILE_NAV_OPENER = 'mobile-nav--opener';
const CLASS_MARKET_SEARCHER = 'market-search-menu';
const CLASS_LOADING_OVERLAY = 'loading-overlay';
const CLASS_LOGO = 'dropdown-menu-widget--logo';
const CLASS_DROPDOWN_SUBMENU_CONTAINER =
	'dropdown-menu-widget--submenu-container';
const CLASS_MAIN_PILLERS_CONTAINER = 'dropdown-menu-widget--center';
const CLASS_PILLER_LINKS = 'dropdown-menu-widget--element';
const CLASS_SUBMENU_LINKS = 'dropdown-menu-widget--submenu-link';
const CLASS_MAIN_LINKS = 'dropdown-menu-widget--link';
const CLASS_CLOSE_SEARCH = 'search-field-drop--close';
const CLASS_MOBILE_LINKS = 'mobile-nav--is-link';
const CLASS_MOBILE_SUBMENU_LINKS = 'mobile-nav--submenu-link';

const CLASS_BACK = 'is-back';
const CLASS_DROPDOWN_LINK = '.dropdown-menu-widget--link';
const CLASS_SCROLLED = 'scrolled';
const CLASS_ACTIVE = 'active';
const CLASS_OPEN = 'open';
const CLASS_CLOSE = 'close';
const CLASS_HIDDEN = 'hidden';
const CLASS_SUBMENU_LIST = '.dropdown-menu-widget--submenu-list';

const TARGET_MARKET = 'markets';
const TARGET_START = 'start';

const selectors = {
	burger: CLASS_MOBILE_NAV_BURGER,
	loadingOverlay: CLASS_LOADING_OVERLAY,
	mobileNavOpener: CLASS_MOBILE_NAV_OPENER,
	logo: CLASS_LOGO,
	pillersContainer: CLASS_MAIN_PILLERS_CONTAINER,
	back: CLASS_BACK,
	closeButton: CLASS_CLOSE_SEARCH,
};
const selectorsAll = {
	navButtons: CLASS_IS_NAVIGATION,
	navPanels: CLASS_MOBILE_NAV_PANELS,
	submenuContainer: CLASS_DROPDOWN_SUBMENU_CONTAINER,
	pillers: CLASS_PILLER_LINKS,
	submenuLink: CLASS_SUBMENU_LINKS,
	mainLinks: CLASS_MAIN_LINKS,
	mobileLinks: CLASS_MOBILE_LINKS,
	mobileSubmenuLinks: CLASS_MOBILE_SUBMENU_LINKS,
};
let activeElement = '';
module.exports = {
	async init() {
		const closeError = this.root.querySelector('.dropdown-menu-widget--close');
		if (closeError)
			closeError.addEventListener('click', this.hideWarning.bind(this));

		this.pageMain = document.querySelector('.page-main');
		fillWithDomElements(this, selectors);
		await asyncImport(this, 'debounce');
		if (this.burger) {
			fillWithDomElementsAll(this, selectorsAll);
			this.isMobileNavOpen = false;
			this.navOpen = true;
			this.scroll = window.pageYOffset;
			this.modal = false;
			this.burger.addEventListener('click', this.onBurgerClick.bind(this));
			this.burgerOriginalLabel = this.burger.getAttribute('aria-label');
			this.burgerOriginalTarget = this.burger.getAttribute('aria-controls');
			this.setMobileNavArias(false);
			this.mobileSubmenuLinks?.forEach(element => {
				element.addEventListener(
					'click',
					this.gtmTracking.bind(
						this,
						element.innerHTML,
						'Level 2',
						'main-navigation',
					),
				);
				element.addEventListener('click', () => {
					this.gtm4Tracking(
						'GA4_event_c_main_navigation',
						'V3-Drop-down-menu',
						element.href,
						element.innerHTML,
						'Level 2',
					);
				});
			});
			this.mobileLinks?.forEach(element => {
				element.addEventListener(
					'click',
					this.gtmTracking.bind(
						this,
						element.innerHTML,
						'Level 1',
						'main-navigation',
					),
				);
				element.addEventListener('click', () => {
					this.gtm4Tracking(
						'GA4_event_c_main_navigation',
						'V3-Drop-down-menu',
						element.href,
						element.innerHTML,
						'Level 1',
					);
				});
			});
		}
		this.listenToMarketRedirect();
		this.initEmitters();
		this.initPanels();
		await asyncImport(this, 'throttle');
		if (this.closeButton)
			this.closeButton.setAttribute(
				'aria-label',
				bodyElement.dataset.closeLabel,
			);

		window.addEventListener(
			'scroll',
			this.throttle(this.onScroll.bind(this), DELAY_THROTTLE),
		);
		this.marketSearcher = this.root.querySelector(
			`.${CLASS_MOBILE_NAV_PANELS} .${CLASS_MARKET_SEARCHER}`,
		);
		this.marketController =
			this.marketSearcher && (await onControllerReady(this.marketSearcher));
		this.root.addEventListener('focusin', () => {
			if (this.navOpen) {
				this.navOpen = false;
				this.update();
			}
		});
		if (this.pillersContainer) {
			this.submenuLink.forEach(element => {
				element.addEventListener(
					'click',
					this.gtmTracking.bind(
						this,
						element.innerHTML,
						'Level 2',
						'main-navigation',
					),
				);
				element.addEventListener('click', () => {
					this.gtm4Tracking(
						'GA4_event_c_main_navigation',
						'V3-Drop-down-menu',
						element.href,
						element.innerHTML,
						'Level 2',
					);
				});
			});
			this.mainLinks.forEach(element => {
				element.addEventListener(
					'click',
					this.gtmTracking.bind(
						this,
						element.innerHTML,
						'Level 1',
						'main-navigation',
					),
				);
				element.addEventListener('click', () => {
					this.gtm4Tracking(
						'GA4_event_c_main_navigation',
						'V3-Drop-down-menu',
						element.href,
						element.innerHTML,
						'Level 1',
					);
				});
			});
			this.pillers.forEach((element, index) => {
				element.addEventListener(
					'focusout',
					this.toggleMenuDropdown.bind(this, element, false),
				);
				element.addEventListener(
					'focusin',
					this.toggleMenuDropdown.bind(this, element, true),
				);
				if (element.dataset.hasSubmenu) {
					element.addEventListener(
						'mouseover',
						this.toggleMenuDropdown.bind(this, element, true),
					);
					element.addEventListener(
						'mouseout',
						this.toggleMenuDropdown.bind(this, element, false),
					);
				} else {
					element.addEventListener(
						'mouseover',
						this.toggleMenuDropdown.bind(this, element, false),
					);
				}
				element.addEventListener('keyup', e => {
					if (e.keyCode === 27) {
						this.toggleMenuDropdown(element, false, e);
						//Timeout needed to ensure keyup event is executed last, after focusout
						setTimeout(() => {
							element
								.querySelector(CLASS_DROPDOWN_LINK)
								.classList.add(CLASS_ACTIVE);
						}, 100);

						element.querySelector(CLASS_DROPDOWN_LINK).blur();
					}
				});
			});
		}
		this.logo?.addEventListener(
			'click',
			this.gtmTracking.bind(this, 'Home', 'click', 'main-navigation'),
		);
		this.logo?.addEventListener('click', () => {
			this.gtm4Tracking(
				'GA4_event_c_main_navigation',
				'V3-Drop-down-menu',
				window.location.host,
				'Home',
				'Level 1',
			);
		});
	},
	toggleMenuDropdown(element, isActive, e) {
		emitter.emit(EVENT_MAIN_NAV_FOCUS);
		e.stopImmediatePropagation();
		const button = element.querySelector(CLASS_DROPDOWN_LINK);
		button.classList.toggle(CLASS_ACTIVE, isActive);
		button.setAttribute('aria-expanded', isActive);
		const elementDropdown = element.querySelector(
			'.dropdown-menu-widget--submenu',
		);
		if (activeElement !== element && activeElement) {
			const activeElementDropdown = activeElement.querySelector(
				'.dropdown-menu-widget--submenu',
			);
			activeElement
				.querySelector(CLASS_DROPDOWN_LINK)
				.classList.toggle(CLASS_ACTIVE, false);

			if (activeElementDropdown) {
				activeElementDropdown.style.height = 0;
				activeElementDropdown.classList.toggle(CLASS_ACTIVE, false);
			}
		}
		if (elementDropdown) {
			const elementDropdownLists =
				elementDropdown.querySelectorAll(CLASS_SUBMENU_LIST);
			elementDropdownLists.forEach((element, index) => {
				//(WCAG) navigating through 3 submenu columns with arrow keys
				element.addEventListener('keyup', e => {
					if (e.keyCode === 39 && index < elementDropdownLists.length) {
						const firstLink =
							elementDropdownLists[
								index + 1 < elementDropdownLists.length ? index + 1 : index
							].firstElementChild.firstElementChild;
						firstLink.classList.add(CLASS_ACTIVE);
						firstLink.focus();
					} else if (e.keyCode === 37 && index > 0) {
						const firstLink =
							elementDropdownLists[index - 1 >= 0 ? index - 1 : index]
								.firstElementChild.firstElementChild;
						firstLink.classList.add(CLASS_ACTIVE);
						firstLink.focus();
					}
				});
			});
			const container = elementDropdown.querySelector(
				'.dropdown-menu-widget--submenu-container',
			);
			const height = container.offsetHeight;
			elementDropdown.style.height = `${isActive ? height + 30 : 0}px`;
			elementDropdown.classList.toggle(CLASS_ACTIVE, isActive);
		}
		activeElement = element;
	},
	initEmitters() {
		emitter.on(EVENT_MAIN_NAV_OPEN, ({ closeCallback, target, label }) => {
			this.modalCallback = closeCallback;
			this.burger && this.burger.classList.add(CLASS_CLOSE);
			this.setBurgerArias(label, true, target);
			this.modal = true;
		});
		emitter.on(EVENT_MAIN_NAV_CLOSE, () => {
			this.modalCallback = null;
			this.burger && this.burger.classList.remove(CLASS_CLOSE);
			this.modal = false;
			this.setMobileNavArias(false);
		});
	},
	setBurgerArias(label, expanded, controls) {
		[
			['label', label],
			['expanded', expanded],
			['controls', controls],
		].forEach(([aria, value]) =>
			this.burger.setAttribute(`aria-${aria}`, value),
		);
	},
	initPanels() {
		this.panels = {};
		this.navPanels &&
			this.navPanels.forEach(panel => {
				const { name } = panel.dataset;
				this.panels[name] = panel;
			});
		this.navButtons &&
			this.navButtons.forEach(button => {
				const { target } = button.dataset;
				if (target === 'markets') {
					button.addEventListener('keydown', e => {
						e.preventDefault();
						if (e.keyCode === 9) {
							setTimeout(() => {
								this.navButtons[1].focus();
							}, 0);
						}
						if (e.keyCode === 13) {
							this.goToPanel('markets');
						}
					});
				}
				button.addEventListener('click', this.goToPanel.bind(this, target));
			});
		this.back?.addEventListener('keydown', e => {
			e.preventDefault();
			if (e.keyCode === 13) {
				this.goToPanel('start');
			}
		});
	},
	goToPanel(panelName) {
		Object.keys(this.panels).forEach(name => {
			const panel = this.panels[name];
			panel.classList.toggle(CLASS_ACTIVE, name === panelName);
			if (name === panelName) {
				//WCAG keyboard accessability (mobile)
				setTimeout(() => {
					this.keyEvents(panelName, panel);
				}, 500);
			}
		});
		if (panelName !== TARGET_START) {
			this.back.classList.remove(CLASS_HIDDEN);
			this.marketSearcher.querySelector('input').value = '';
		} else {
			this.back.classList.add(CLASS_HIDDEN);
		}
		if (panelName === TARGET_MARKET) this.activateMarket();
	},
	keyEvents(panelName, panel) {
		const panelLinks = panel.querySelectorAll('.mobile-nav--submenu-link');

		if (panelName !== 'start') {
			if (panelName !== 'markets') {
				panelLinks[0].focus();
				panelLinks[panelLinks.length - 1].addEventListener('keydown', e => {
					if (e.keyCode === 9) {
						e.preventDefault();
						this.back.focus();
					}
				});
				panelLinks[0].addEventListener('keydown', e => {
					if (e.keyCode === 9) {
						if (e.shiftKey) {
							e.preventDefault();
							this.burger.focus();
						}
					}
				});
			}
			this.back?.addEventListener('keydown', e => {
				e.preventDefault();
				if (e.keyCode === 9) {
					this.root.querySelector('.search--glass').focus();
				}
				if (e.keyCode === 9) {
					if (e.shiftKey && panelName !== 'markets') {
						panelLinks[panelLinks.length - 1].focus();
					} else if (e.shiftKey && panelName === 'markets') {
						this.burger.focus();
					}
				}
			});
			this.burger?.addEventListener('keydown', e => {
				if (e.keyCode === 9) {
					if (!e.shiftKey) {
						Object.keys(this.panels).forEach(name => {
							if (
								panel.classList.contains(CLASS_ACTIVE) &&
								panel.dataset.name !== 'start' &&
								panel.dataset.name !== 'markets'
							) {
								e.preventDefault();
								panelLinks[0].focus();
							}
						});
					}
				}
			});
			this.root
				.querySelector('.search--glass')
				.addEventListener('keydown', e => {
					if (e.keyCode === 9) {
						e.preventDefault();
						if (e.shiftKey) {
							this.back.focus();
						} else {
							this.burger.focus();
						}
					}
				});
		}
		if (panelName === 'markets') {
			const searchInput = this.root.querySelector(
				'.mobile-nav--panel .market-search-menu input',
			);
			const searchSuggestionLinks = this.root.querySelectorAll(
				'.mobile-nav--panel .market-search-menu .search-field-drop--suggestions a',
			);
			searchSuggestionLinks.forEach(element => {
				element.removeAttribute('tabindex');
			});
			searchInput.focus();
			searchInput.addEventListener('keydown', e => {
				if (e.keyCode === 9) {
					e.preventDefault();
					if (e.shiftKey) {
						this.burger.focus();
					} else {
						searchSuggestionLinks[0].focus();
					}
				}
			});
			searchSuggestionLinks[searchSuggestionLinks.length - 1]?.addEventListener(
				'keydown',
				e => {
					e.preventDefault();
					if (e.keyCode === 9) {
						this.burger.focus();
					}
				},
			);
			this.burger?.addEventListener('keydown', e => {
				if (e.keyCode === 9) {
					if (!e.shiftKey) {
						Object.keys(this.panels).forEach(name => {
							if (
								panel.classList.contains(CLASS_ACTIVE) &&
								panel.dataset.name !== 'start'
							) {
								e.preventDefault();
								searchInput.focus();
							}
						});
					}
				}
			});
		}
	},

	listenToMarketRedirect() {
		emitter.on(EVENT_MARKET_REDIRECT_INIT, ({ className }) => {
			this.root.classList.add(className);
			this.pageMain.classList.add(className);
		});
		emitter.on(EVENT_MARKET_REDIRECT_CLOSE, ({ className }) => {
			this.root.classList.remove(className);
			this.pageMain.classList.remove(className);
		});
	},
	onBurgerClick() {
		if (this.modal) {
			this.modalCallback();
			this.burger.classList.remove(CLASS_CLOSE);
			this.modal = false;
			this.modalCallback = null;
		} else {
			this[this.isMobileNavOpen ? 'closeMobileNav' : 'openMobileNav']();
		}
		this.marketSearcher.querySelector('input').value = '';
		this.activateMarket();
	},
	onScroll() {
		const bottomLimit =
			document.documentElement.offsetHeight - window.innerHeight - 100;
		if (
			(window.pageYOffset > this.scroll &&
				window.pageYOffset >= 10 &&
				!this.modal) ||
			window.pageYOffset > bottomLimit
		) {
			this.navOpen = true;
		} else {
			this.navOpen = false;
		}
		this.update();
		this.scroll = window.pageYOffset;
	},
	async openMobileNav() {
		if (this.isMobileNavOpen) return;
		this.mobileNavOpener.removeAttribute('hidden');
		await awaitNextFrame();
		this.root.classList.add(CLASS_OPEN);
		freezeScroll();
		this.isMobileNavOpen = true;
		this.setMobileNavArias(true);
	},
	async closeMobileNav() {
		if (!this.isMobileNavOpen) return;
		this.root.classList.remove(CLASS_OPEN);
		unfreezeScroll();
		await awaitEventOn(this.mobileNavOpener, 'transitionend');
		this.mobileNavOpener.setAttribute('hidden', '');
		this.isMobileNavOpen = false;
		this.setMobileNavArias(false);
		this.activateMarket();
	},
	setMobileNavArias(isOpen) {
		this.setBurgerArias(
			this.burgerOriginalLabel,
			isOpen,
			this.burgerOriginalTarget,
		);
	},
	update() {
		const pageMain = document.querySelector('.page-main');
		const shouldAddClass = pageMain
			? pageMain.offsetHeight > window.innerHeight + 500
			: true;

		if (this.navOpen && !this.isMobileNavOpen && shouldAddClass) {
			bodyElement.classList.add(CLASS_SCROLLED);
			emitter.emit(EVENT_MAIN_NAV_FOLDING);
		} else {
			bodyElement.classList.remove(CLASS_SCROLLED);
			emitter.emit(EVENT_MAIN_NAV_UNFOLDING);
		}
	},
	activateMarket() {
		this.marketController && this.marketController.fetchCountries();
	},
	gtmTracking(label, action, category) {
		trackGtm({
			eventCategory: category,
			eventAction: action,
			eventLabel: label,
		});
	},
	gtm4Tracking(event, widgetName, url, text, level) {
		trackGtm4({
			event: event,
			widget_name: widgetName,
			link_url: url,
			link_text: text,
			level: level,
		});
	},
	hideWarning() {
		const warningError = this.root.querySelector(
			'.dropdown-menu-widget--warning',
		);
		warningError.style.display = 'none';
	},
};
